import { ProjectContents } from '@console/common/constants';
import { connect } from 'react-redux';
import type { Location, NavigateFunction } from 'react-router';
import { matchPath } from 'react-router';
import type { AppThunkAction, AppThunkDispatch } from '../../actions/thunkType';
import type { PathParams } from '../../components/project/FloatingButton';
import FloatingButton from '../../components/project/FloatingButton';

const toggleMessageThread =
  (
    navigate: NavigateFunction,
    params: PathParams,
    location: Location
  ): AppThunkAction<void> =>
  () => {
    const { urlCode } = params;
    if (isMessageThreadShown(location.pathname)) {
      navigate(
        `/console/projects/${urlCode}/${ProjectContents.PROJECT_DETAIL}`
      );
    } else {
      navigate(
        `/console/projects/${urlCode}/${ProjectContents.MESSAGE_THREAD}`
      );
    }
  };

export const isMessageThreadShown = (currentPath: string) =>
  matchPath(
    `/console/projects/:urlCode/${ProjectContents.MESSAGE_THREAD}`,
    currentPath
  );

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  toggleMessageThread: (
    navigate: NavigateFunction,
    params: PathParams,
    location: Location
  ) => dispatch(toggleMessageThread(navigate, params, location))
});

export type FloatingButtonPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type FloatingButtonPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(FloatingButton);
